import { type LinePattern, type Point, safeAbsurd } from '@ipfabric/utils';
import type { Graphics } from 'pixi.js';
import { getQuadraticCurve } from './getQuadraticCurve';

export const drawQuadraticCurve = (
  edgeLine: Graphics,
  start: Point,
  control: Point,
  end: Point,
  pattern: LinePattern,
  thickness: number,
  color: number,
  offset: number,
): void => {
  const points = getQuadraticCurve(start, control, end, pattern, thickness);

  switch (pattern) {
    case 'solid': {
      edgeLine.moveTo(start.x, start.y);
      for (const curvePoint of points) {
        edgeLine.lineTo(curvePoint.x, curvePoint.y);
      }
      break;
    }
    case 'dashed':
      points.forEach((curvePoint, index) => {
        if (index % 3 === offset) {
          const nextCurvePoint = points[index + 1];
          if (nextCurvePoint !== undefined) {
            edgeLine.moveTo(curvePoint.x, curvePoint.y);
            edgeLine.lineTo(nextCurvePoint.x, nextCurvePoint.y);
          }
        }
      });
      break;
    case 'dotted': {
      for (const curvePoint of points) {
        edgeLine.beginFill(color);
        edgeLine.lineStyle(0);
        edgeLine.drawCircle(curvePoint.x, curvePoint.y, thickness / 2);
        edgeLine.endFill();
      }
      break;
    }
    default:
      safeAbsurd(pattern, 'Invalid line pattern', undefined);
  }
};
